import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Field } from "@bpm/models";
import { Status } from "@common/models";
import {
  Column,
  DataTableInput,
  DataTableOutput,
  Order,
  Search,
} from "@core/models/datables";
import { environment } from "environments/environment";
import { Observable, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class FieldService {
  //EndPoint para controlador de este objeto en backend
  private fieldApiEndpoint = `${environment.bpmApiUrl}/api/fields`;

  //Establece las columnas para el paginado del lado del servidor
  private columns: Column[] = [
    {
      data: "id",
      name: "",
      searchable: true,
      orderable: true,
      search: new Search(),
    },
    {
      data: "name",
      name: "",
      searchable: true,
      orderable: true,
      search: new Search(),
    },
    {
      data: "description",
      name: "",
      searchable: true,
      orderable: true,
      search: new Search(),
    },
    {
      data: "status.code",
      name: "",
      searchable: true,
      orderable: true,
      search: {
        regex: true,
        value: "ACT",
      },
    },
  ];

  constructor(private _http: HttpClient) {}

  //Obtiene todos los campos
  getAllFields() {
    return this._http.get<Field[]>(this.fieldApiEndpoint);
  }

  //Obtiene los campos por nombre
  getFieldsByName(name: string) {
    if (name === "") return of(null);
    return this._http.get<Field[]>(`${this.fieldApiEndpoint}/view/${name}`);
  }

  //Obtiene todos los campos paginados
  getAllFieldsPaged(
    page: number,
    quantity: number,
    order: Order,
    searchText: string
  ) {
    const input = this.createDataTableInput(page, quantity, order, searchText);
    return this._http.post<DataTableOutput<Field>>(
      `${this.fieldApiEndpoint}/index`,
      input
    );
  }

  //Obtiene los campos por Id
  /**
   * Gets a field from db based on its id
   * @param {number} fieldId - ID of field to get from db
   * @returns {Observable<Field>} Retrieved field from db
   */
  getFieldById(fieldId: Number): Observable<Field> {
    return this._http.get<Field>(`${this.fieldApiEndpoint}/${fieldId}`);
  }

  //Crea un nuevo campo
  createField(field: Field) {
    field.status = new Status();
    field.status.code = "ACT";
    return this._http.post<{ message: String; field: Field }>(
      this.fieldApiEndpoint,
      field
    );
  }

  //Actualiza el campo recibido
  updateField(field: Field) {
    return this._http.put<{ message: String; field: Field }>(
      `${this.fieldApiEndpoint}/${field.id}`,
      field
    );
  }

  //Cambia el estado del campo
  changeFieldStatus(fieldId: Number, statusCode: String) {
    return this._http.put<{ field: Field; message: String }>(
      `${this.fieldApiEndpoint}/${fieldId}/${statusCode}`,
      null
    );
  }

  /**
   * Función que crea una entrada para datatable por medio de parametros
   * @param page Indica el número de página
   * @param quantity Indica la cantidad de unidades a solicitar
   * @param order Indica el orden que tendrá la columna
   * @param searchText Indica el texto que se va a filtrar
   * @returns Devuelve una entrada para datatable
   */
  private createDataTableInput(
    page: number,
    quantity: number,
    order: Order,
    searchText: string
  ): DataTableInput {
    let input = new DataTableInput();
    input.start = page * quantity;
    input.length = quantity;
    if (searchText !== "") {
      input.search.regex = true;
      input.search.value = searchText;
    }
    if (order) {
      input.order.push(order);
    }
    input.columns = this.columns;
    return input;
  }
}
